import {FourthLevelNavigation} from './FourthLevelNavigation.jsx';
import {NewFlag} from './NewFlag.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';
import {useMemo, useRef} from 'react';
import {useNaviFocusTrap} from '@header/scripts/components/hooks/use-navi-focus-trap.js';

export default function ThirdLevelColumns({texts, thirdLevelItems, closeLayer}) {
    const thirdLevelRef = useRef(null);
    useNaviFocusTrap(thirdLevelRef, 'third', closeLayer);

    const itemMap = useMemo(() => {
        const map = new Map();
        let counter = 0;
        if (thirdLevelItems.length > 0) {
            map.set(counter, []);
            thirdLevelItems.forEach((item) => {
                if (!item.showInNextColumn) {
                    map.set(counter, [...map.get(counter), item]);
                } else {
                    counter++;
                    map.set(counter, [item]);
                }
            });
        }
        return map;
    }, [thirdLevelItems]);

    const navigationItems = useMemo(() => {
        return Array.from(itemMap).map(([key, value]) => ({key, value}));
    }, [itemMap]);

    const handleClick = (id) => {
        const naviLmValue = `hn\\${id}\\\\`;
        Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
    };

    return (
        <div id="desktop-navigation-third-level" ref={thirdLevelRef} style={{display: 'flex'}}>
            {navigationItems?.map((column) => (
                <div className="navigation__level-column" key={column.key}>
                    {column.value
                        .filter((item) => !item.overviewItem)
                        .map((item, index) => {
                            const titleColor = item.fontColor || 'primary';
                            return (
                                <div
                                    className={`navigation__item -level:third
                                    ${item.active ? 'is-active' : ''}
                                    ${item.extraSpacing && index !== 0 ? '-spacing:extra' : ''}`}
                                    key={item.id}
                                    onClick={() => handleClick(item.id)}
                                >
                                    <a
                                        href={item.url}
                                        className={`navigation__item-label navigation__item-link text-clr-${titleColor}`}
                                    >
                                        {item.hasNewFlag && <NewFlag />}
                                        {item.title}
                                    </a>
                                    {item.slicedTopSubNavigationItemIds &&
                                        item.slicedTopSubNavigationItemIds.length > 0 && (
                                            <FourthLevelNavigation thirdLevelItem={item} texts={texts} />
                                        )}
                                </div>
                            );
                        })}
                </div>
            ))}
        </div>
    );
}
